import React, { ReactNode, Suspense } from "react";
import { useAuthContext } from "../auth/hooks";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "../Icons/LoadingSpinner";


// Assets
const AssetList = React.lazy(() => import("../pages/Assets/asset-list/asset-list"));

const ProtectedAdminHRItRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
    const {user} = useAuthContext()

    const isAdmin = localStorage.getItem('roleName');
    return (['HR','IT'].includes(user?.department)||isAdmin==='Admin') ? (
        <> {children} </>
    ) : (
        <Navigate to="/dashboard" />
    );
};

const renderProtectedHRITRoute = (Component: React.ComponentType<any>, props?: any) => (
    <Suspense fallback={<LoadingSpinner className="mr-2 h-full w-14 animate-spin" />}>
        <ProtectedAdminHRItRoute>
            <Component {...props} />
        </ProtectedAdminHRItRoute>
    </Suspense>
);
export const renderITRoutes = [
    {
        path: "/company-assets",
        element: renderProtectedHRITRoute(AssetList),
        title: "Profile",
        role: ['admin'],
    },
]